import BvIcon from 'volta/components/bv-icon';
import BvInline from 'volta/components/bv-inline';
import BvText from 'volta/components/bv-text';
import BvTooltip from 'volta/components/bv-tooltip';
import orElse from 'volta/helpers/or-else';
import tElse from 'volta/helpers/t-else';

import type { TOC } from '@ember/component/template-only';
import type { SafeString } from '@ember/template';
import type { BvIconSignature } from 'volta/components/bv-icon';

interface PoWorkbenchPrioritySelectItemSignature {
  Args: {
    color?: BvIconSignature['Args']['color'];
    icon?: string;
    minimized?: boolean;
    text?: string | SafeString;
  };
}

const PoWorkbenchPrioritySelectItemComponent: TOC<PoWorkbenchPrioritySelectItemSignature> =
  <template>
    <BvInline @gap={{unless @minimized '1'}} @blockAlign='center'>
      <BvIcon @glyph={{orElse @icon 'flag-outline'}} @color={{orElse @color 'gray'}} />
      {{#if @text}}
        {{#if @minimized}}
          <BvTooltip @text={{tElse @text}} />
        {{else}}
          <BvText @text={{tElse @text}} />
        {{/if}}
      {{/if}}
    </BvInline>
  </template>;

export default PoWorkbenchPrioritySelectItemComponent;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'PoWorkbench::PrioritySelect::Item': typeof PoWorkbenchPrioritySelectItemComponent;
    'po-workbench/priority-select/item': typeof PoWorkbenchPrioritySelectItemComponent;
  }
}
